import { render, staticRenderFns } from "./rujukan.vue?vue&type=template&id=4eff7700&scoped=true"
import script from "./rujukan.vue?vue&type=script&lang=js"
export * from "./rujukan.vue?vue&type=script&lang=js"
import style0 from "./rujukan.vue?vue&type=style&index=0&id=4eff7700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eff7700",
  null
  
)

export default component.exports